import './WifiDisconnection.css';

import React, { useState, useEffect } from 'react';
import { type NetworkInfoResult, type WifiNetwork } from '@lib/networkApiTypes';
import { useWifiNetworks } from '@src/contexts';
import { GoBackButton, DisconnectButton } from './components';
import networkApi from '@lib/networkApi';

interface WifiDisconnectionProps {
  wifiNetwork: WifiNetwork
  onCancel: () => void
}

export const WifiDisconnection = ({ wifiNetwork, onCancel }: WifiDisconnectionProps): JSX.Element => {
  const { disconnectFromWifi, isDisconnectingFromWifi } = useWifiNetworks();
  const [networkResult, setNetworkResult] = useState<NetworkInfoResult | undefined>(undefined);

  useEffect(() => {
    const networkInfoRequestCancellation = networkApi.getNetworkInfo(
      'pendantWlan',
      jsonResponse => {
        setNetworkResult(JSON.parse(jsonResponse));
      },
      (xhr, status, error) => {
        setNetworkResult(undefined);
      },
    );
    return networkInfoRequestCancellation;
  }, []);

  return (
    <div id="wifi_disconnection">
      <GoBackButton onClick={onCancel} disabled={isDisconnectingFromWifi} />
      <div id="wifi_disconnection_controls">
        <div id="wifi_disconnection_title">{wifiNetwork.ssid}</div>
        <NetworkMetadata name="Ip" value={networkResult?.ip} />
        <NetworkMetadata name="Netmask" value={networkResult?.netmask} />
        <NetworkMetadata name="Gateway" value={networkResult?.gateway} />
        <DisconnectButton onClick={() => { void disconnectFromWifi(); }} disabled={isDisconnectingFromWifi} />
      </div>
    </div>
  );
};

interface NetworkMetadataProps {
  name: string
  value?: string | undefined
}

const NetworkMetadata = ({ name, value = 'unavailable' }: NetworkMetadataProps): JSX.Element => {
  return (
    <div className="wifi_disconnection_metadata_row">
      <div className="wifi_disconnection_metadata_row_title">{name}</div>
      <div>{value}</div>
    </div>
  );
};
